<template>
  <div class="goal-config-general">
    <el-form @submit.native.prevent v-if="goal_meta.$ready">

      <el-alert v-if="user_input_error" type="error">Error: Invalid input <!-- TODO more details --></el-alert>

      <!-- SHOW INFO IF ARCHIVED -->
      <div class="content">
        <el-alert v-if="goal_meta.deleted" type="error" center show-icon :closable="false" class="my-4">
          This goal is achived and can not be edited anymore.
        </el-alert>
      </div>

      <div class="form-title">Goal name:</div>
      <el-input
        :disabled="!currentUserIsAdmin"
        placeholder="Your new goal..."
        :value="goal_meta.name"
        @change="onUpdateGoalName($event)"
        class="inline-input"
        autocomplete="off"
        autofocus />

      <div class="form-title">Goal type:</div>
      <div class="pt-4 pb-4">
        <el-switch
          :disabled="!currentUserIsAdmin"
          :value="goal_meta.isTeamgoal"
          @input="goal_meta.update({ isTeamgoal: $event })"
          active-text="Team Goal"
          inactive-text="Private Goal"></el-switch>
      </div>

      <div class="form-title">Image:</div>
      <!-- TODO: Show preview -->
      <ImageUpload
        :value="goal_meta.picture"
        @input="goal_meta.update({ picture: $event })"
        bucket="goal_pics" />

      <!--
      <div class="form-title">Rules:</div>
      <el-input
        type="textarea"
        v-model="goalForm.rules"
        :disabled="!currentUserIsAdmin"></el-input>
      -->

      <div class="form-title">Housekeeping:</div>
      <el-button
        @click="onRunHousekeeping"
        type="warning"
        :disabled="!currentUserIsAdmin">Run Housekeeping</el-button>

      <div class="form-title">Archive goal:</div>
      <div class="pt-4 pb-4">
        <el-switch
          :disabled="!currentUserIsAdmin"
          :value="goal_meta.deleted"
          @input="goal_meta.update({ deleted: $event })"
          ></el-switch>
      </div>

      <div class="form-title">Delete Goal (You must be the owner):</div>
      <el-button
        type="danger"
        :disabled="!currentUserIsOwner"
        @click="onDeleteGoal( false )">
        Yes, I really want to delete this goal permanently.
      </el-button>
    </el-form>

    <!--
    <span slot="footer" class="dialog-footer">
      <el-button @click="goalFormVisible = false">Close</el-button>
    </span>
    -->
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import ImageUpload from '@/components/Elements/ImageUpload'
import GoalManagementMixin from "@/components/Mixins/GoalManagement"

export default {
  mixins: [ GoalManagementMixin ],
  props: {
    goalId: { required: true }
  },
  data: () => ({
    user_input_error: false,
  }),
  mounted() {
  },
  computed: {
    ...mapGetters("user", [
      "userAuth"
    ]),

    goal_meta() {
      return this.$models.goalMeta.getNode( this.goalId );
    },

    commitment_list() {
      return this.$models.commitmentMeta.with({ goalId: this.goalId }).getList();
    },

    /* TODO: Move to model getter */
    currentUserIsAdmin() {
      /*
      let members = this.goal_meta.members;
      if ( this.userAuth.id in members && members[this.userAuth.id] ) {
        return members[this.userAuth.id].isAdmin;
      }
      return false;
      */
      return true // TODO
    },
  },
  methods: {
    // -------------------------------------------------------------------------

    onValidateInput() {
      /*
      this.goalForm = this.$models.goalMeta.getNode( this.goalId ).clone();
      this.goalForm.setValidationBehaviour('ELEMENT_VALIDATION')
      console.log("[GeneralSettingsPage] This instance will be used for editing", this.goalForm);

      if ( !this.goalForm.$isValid() ) {
        this.user_input_error = true;
        this.user_input_invalid_list = Object.keys(this.goalForm.$invalid);
        return
      }
      */
      return true;
    },

    onRunHousekeeping() {
      this.$models.task.fetch_phantom_tasks( this.goalId ).then(list => {
        list.forEach(task => {
          console.log("Removing phantom task", task.$id);
          // `/goal/${this.goalId}/user_list/${task.memberId}/task_meta/${task.$id}`)
          task.remove()
        })
        this.$message.success('Housekeeping done.');
      })
    },
  },
  components: {
    ImageUpload
  }
}
</script>

<style>
.goal-config-general .form-title {
  font-weight: bold;
  margin-top: 0.8em;
  margin-bottom: 0.4em;
}
</style>
